import React from "react";
import NextLink from "@insightfulscience/smart-react/NextLink";
import Block from "@insightfulscience/atomic-react/Block";
import Icon from "@insightfulscience/atomic-react/Icon";
import { shape, string } from "prop-types";

const BackLink = ({ backLink: { href, title } }) => {
	return (
		<Block sx={{ textAlign: "left" }} spacing={{ mb: 10 }}>
			<NextLink href={href}>
				<Icon name="chevron-left" spacing={{ mr: 3 }} />
				{title}
			</NextLink>
		</Block>
	);
};

BackLink.propTypes = {
	backLink: shape({
		href: string.isRequired,
		title: string.isRequired,
	}),
};

export default BackLink;
